import { NavLink } from "react-router-dom";
import { Button, Link, Stack } from "@chakra-ui/react";
export default function PageButtons({
  config,
  pageData,
}: Record<string, any>): JSX.Element {
  return (
    <Stack
      data-testid="extraButtons"
      direction={config?.direction}
      align="center"
      justify="center"
      padding="2rem 0"
      spacing={config?.spacing}
      flexWrap="wrap"
      rowGap={4}
    >
      {pageData?.extra?.webButtons.map((button: any) => {
        return (
          <section key={button.buttonTitle}>
            {button?.buttonFeature && (
              <NavLink
                to={`/${button?.buttonFeature?.replace(/\s+/g, "")}`}
                role="link"
              >
                <Button
                  key={button}
                  bg={button?.buttonBackgroundColor}
                  color={button?.buttonTextColor}
                  size="lg"
                >
                  {button?.buttonTitle.toUpperCase()}
                </Button>
              </NavLink>
            )}
            {button?.buttonUrl && (
              <Link
                href={button?.buttonUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  key={button}
                  bg={button?.buttonBackgroundColor}
                  color={button?.buttonTextColor}
                  size="lg"
                >
                  {button?.buttonTitle.toUpperCase()}
                </Button>
              </Link>
            )}
          </section>
        );
      })}
    </Stack>
  );
}
